import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { CONTACT, waLink, WA_DEFAULT_MSG } from "@/lib/site";

const SECTIONS = [
  {
    title: "1. Who We Are",
    body: "NGCONDE Courier Service is a South African courier and logistics contractor providing parcel delivery and bakkie transport capacity to businesses under contract. This policy explains how we handle personal information submitted through this website, in line with the Protection of Personal Information Act (POPIA), Act 4 of 2013.",
  },
  {
    title: "2. Information We Collect",
    body: "When you submit a partnership enquiry we collect the details you provide: your name, company name, work email address, phone/WhatsApp number, the contract requirement you select, and the content of your message. We do not collect payment information through this website, and we do not use tracking cookies of our own beyond standard, anonymous site availability monitoring.",
  },
  {
    title: "3. How We Use Your Information",
    body: "We use enquiry information for one purpose: to respond to your partnership enquiry and to prepare a proposal for contract delivery services. This may include contacting you on the phone number or WhatsApp number you supplied. We do not sell, rent or trade your personal information to third parties, and we do not add you to marketing lists.",
  },
  {
    title: "4. Lawful Basis & Processing",
    body: "We process enquiry information on the basis of your consent, given when you submit the form or contact us directly. Processing is limited to what is necessary to respond to your request and, where a partnership proceeds, to execute and administer the resulting contract.",
  },
  {
    title: "5. Storage & Security",
    body: "Enquiry submissions are stored in a secured database with access limited to NGCONDE Courier Service personnel who need them to respond to you. We apply reasonable technical and organisational measures to protect personal information against loss, unauthorised access and disclosure.",
  },
  {
    title: "6. Retention",
    body: "We keep enquiry information only as long as needed to respond to your request and, where relevant, for the duration of any resulting business relationship and any period required by South African law. Enquiries that do not lead to a partnership are deleted within 12 months.",
  },
  {
    title: "7. Your Rights",
    body: "Under POPIA you may request access to the personal information we hold about you, ask us to correct or delete it, withdraw consent, or object to processing. To exercise any of these rights, contact us using the details below. We will respond within a reasonable period.",
  },
  {
    title: "8. Third-Party Links",
    body: "This website links to WhatsApp for convenience. When you use WhatsApp, your communication is also subject to WhatsApp's own privacy policy, which we encourage you to review.",
  },
  {
    title: "9. Changes to This Policy",
    body: "We may update this policy from time to time. The latest version will always be available on this page.",
  },
];

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#080C14]">
      <Navbar />

      <section className="px-5 pb-20 pt-32 md:pt-40 lg:px-8">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <p className="flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#FF6B00]">
              <span className="inline-block h-px w-8 bg-[#FF6B00]" aria-hidden="true" />
              Legal
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="mt-4 font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-white sm:text-5xl">
              Privacy Policy
            </h1>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
              POPIA-aligned · Last updated: February 2026
            </p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={Math.min(i * 0.04, 0.2)}>
                <section data-testid={`privacy-section-${i + 1}`}>
                  <h2 className="font-display text-lg font-extrabold uppercase tracking-tight text-white md:text-xl">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-slate-300 md:text-base">
                    {s.body}
                  </p>
                </section>
              </Reveal>
            ))}

            <Reveal>
              <section
                data-testid="privacy-contact"
                className="rounded-2xl border border-white/10 bg-[#0D1424] p-6 md:p-8"
              >
                <h2 className="font-display text-lg font-extrabold uppercase tracking-tight text-white md:text-xl">
                  10. How to Contact Us
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-300 md:text-base">
                  For any privacy request or question, contact the information
                  officer:
                </p>
                <ul className="mt-4 space-y-2 text-sm">
                  <li>
                    <a
                      href={`mailto:${CONTACT.email}`}
                      data-testid="privacy-email-link"
                      className="break-all text-[#FF6B00] transition-colors hover:text-white"
                    >
                      {CONTACT.email}
                    </a>
                  </li>
                  <li>
                    <a
                      href={`tel:${CONTACT.callNumber}`}
                      data-testid="privacy-call-link"
                      className="text-slate-300 transition-colors hover:text-[#FF6B00]"
                    >
                      {CONTACT.callDisplay}
                    </a>
                  </li>
                  <li>
                    <a
                      href={waLink(WA_DEFAULT_MSG)}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="privacy-whatsapp-link"
                      className="text-[#25D366] transition-colors hover:text-white"
                    >
                      WhatsApp {CONTACT.whatsappDisplay}
                    </a>
                  </li>
                </ul>
              </section>
            </Reveal>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
